import { createSetFilter } from "../common/filter";

export const setIdeaFilter = createSetFilter('list-ideas-filter');